import { Alert } from "antd";

export enum TransferState {
    Start,
    Validated,
    Submitting,
    Success,
    Error
}

export const AlertState = (props: {
    state: TransferState,
    validatedMessage: string
}) => {
    const { state, validatedMessage } = props;

    if (state === TransferState.Validated) {
        return <Alert
            type="info"
            message={validatedMessage}
            description="Click 'Transfer Funds' to proceed, or 'Cancel' to abort the transfer."
        />;
    } else if (state === TransferState.Success) {
        return <Alert
            type="success"
            message="Transfer Complete!"
            showIcon
        />;
    } else if (state === TransferState.Error) {
        return <Alert
            type="error"
            message="Unable to process transfer, an unexpected error occurred."
            showIcon
        />;
    }

    // Start & Submitting have no alert
    return null;
}